import { render, staticRenderFns } from "./downloadSection.vue?vue&type=template&id=1130e584&scoped=true&"
import script from "./downloadSection.vue?vue&type=script&lang=js&"
export * from "./downloadSection.vue?vue&type=script&lang=js&"
import style0 from "./downloadSection.vue?vue&type=style&index=0&id=1130e584&prod&lang=css&"
import style1 from "./downloadSection.vue?vue&type=style&index=1&id=1130e584&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1130e584",
  null
  
)

export default component.exports